import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = [...comics].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  ).slice(0, 8);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">实时追踪你最爱的连载漫画</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            更多作品
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.slug}`}
              className="flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 group cursor-pointer"
              data-product-shop
            >
              <div className="flex-shrink-0 w-20 h-28 overflow-hidden rounded-lg">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 妖精漫画免费阅读`}
                  title={`${comic.title} - 妖精漫画免费韩漫`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                </div>
                <div>
                  <div className="flex flex-wrap items-center gap-1.5 mt-2">
                    {comic.tags.slice(0, 2).map((tag) => (
                      <span key={tag} className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="flex items-center justify-between mt-2">
                    <span className="text-xs text-foreground-400">
                      更新至 {comic.chapters} 话
                    </span>
                    {comic.status === '连载中' && (
                      <span className="inline-block w-1.5 h-1.5 rounded-full bg-green-500"></span>
                    )}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}